import React from 'react';
import { Link } from 'react-router-dom';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { Icon, ReplaceLink } from 'js/components';
import { replaceSearchParam } from 'js/components/Charts/chart-search';
import { snapshotSetPath } from 'js/routes/Organizations/components/OrgSnapshots/org-snapshot-utils';

export const DETAIL_TAB_LABELS = {
  recommendations: 'Overview',
  'squad-scorecard': 'Scorecard',
  'org-trends': 'Trends',
  insights: 'Insights',
  analyze: 'Insights',
};

export function orgDetailBasePath(workspaceId, orgId, assessmentKey) {
  return `/w/${workspaceId}/orgs/${orgId}/${encodeURIComponent(
    assessmentKey
  )}/detail`;
}

export function isDetailTabActive(pathname, baseUrl, key) {
  if (key === 'squad-scorecard') {
    return (
      pathname === `${baseUrl}/squad-scorecard` ||
      pathname.startsWith(`${baseUrl}/squad-scorecard/`)
    );
  }
  return pathname.startsWith(`${baseUrl}/${key}`);
}

export default function OrgDetailTabs({
  workspaceId,
  orgId,
  assessmentKey,
  isRubric = false,
  views = [],
  pathname = '',
  search = '',
  snapshotsActive = false,
}) {
  if (!assessmentKey) {
    return null;
  }

  const detailBase = orgDetailBasePath(workspaceId, orgId, assessmentKey);
  const snapshotsTo = snapshotSetPath(
    workspaceId,
    orgId,
    isRubric ? 'rubric' : 'assessment',
    assessmentKey
  );

  return (
    <Nav className="tab-nav nav-underline">
      {views.map((key) => (
        <NavItem key={key}>
          <NavLink
            tag={ReplaceLink}
            data-view={key}
            active={
              !snapshotsActive && isDetailTabActive(pathname, detailBase, key)
            }
            to={{
              pathname: `${detailBase}/${key}`,
              search: replaceSearchParam(
                search,
                'depth',
                key === 'squad-scorecard' ? 'full' : null
              ),
              state: { noScroll: true },
            }}
          >
            {DETAIL_TAB_LABELS[key] ?? key}
          </NavLink>
        </NavItem>
      ))}
      <NavItem>
        <NavLink
          tag={Link}
          data-view="snapshots"
          active={snapshotsActive}
          to={snapshotsTo}
          title="Opens snapshot history"
        >
          Snapshots
          <Icon icon={faChevronRight} size="xs" className="ml-1" />
        </NavLink>
      </NavItem>
    </Nav>
  );
}
